import { format, isValid, parseJSON } from "date-fns";

export const formatDateTime = (iso: string) => {
  if (!iso) return "";
  const date = parseJSON(iso);
  return isValid(date) ? format(date, "MMM d, yyyy 'at' h:mm a") : "";
};

// "6 chars + ... + 4 chars" — keeps table cells compact while the prefix stays recognisable.
// IDs shorter than the truncated form pass through unchanged.
export const truncateIdForCell = (id: string): string => {
  if (!id) return "";
  if (id.length <= 13) {
    return id;
  }
  return `${id.slice(0, 6)}...${id.slice(-4)}`;
};
